/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable eqeqeq */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import 'url-search-params-polyfill';
import Description from '../../text/Description';
import { isMobileDevice } from '../../../utils/misc';
import Img from '../../Img';
import { getApiAxiosInstance } from '../../../utils/network';
import styles from './schoolSearch.scss';

class SchoolSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            showDropDown: false,
            options: [],
            query: props.defaultValue || '',
            top: 10,
            skip: 0,
            isEnd: false,
            searched: false,
        };

        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.handlePaste = this.handlePaste.bind(this);
        this.fetchSearchResults = this.fetchSearchResults.bind(this);
        this.handleLinkClick = this.handleLinkClick.bind(this);
        this.handleSearchBackClick = this.handleSearchBackClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.props.query) {
            this.setState({
                query: this.props.query,
            });
        }
    }

    componentDidUpdate() {
        // console.log('HighSchoolSearch state', this.state);
        // console.log('HighSchoolSearch props', this.props);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && this.state.showDropDown) {
            this.setState({
                showDropDown: false,
            });
        }
    }

    handleOnFocus() {
        if (this.state.query.length > 0) {
            this.setState({
                showDropDown: true,
            });
        }
    }

    handleKeyUp(event) {
        const query = event.target.value;
        if (query.length > 0) {
            if (isMobileDevice()) {
                window.scrollTo(0, 0);
            }
            this.setState({
                isLoading: true,
                showDropDown: true,
                query,
                options: [],
                skip: 0,
                isEnd: false,
            }, () => {
                this.fetchSearchResults();
            });
        } else {
            this.setState({
                query: '',
                options: [],
                skip: 0,
                showDropDown: false,
                isEnd: false,
            });
        }
        if (this.props.onChange) {
            this.props.onChange(query);
        }
    }

    handlePaste(event) {
        const { target } = event;
        setTimeout(() => {
            const query = target.value.trim();
            if (query.length > 0) {
                this.setState({
                    isLoading: true,
                    showDropDown: true,
                    query,
                    options: [],
                    skip: 0,
                    isEnd: false,
                }, () => {
                    this.fetchSearchResults();
                });
            } else {
                this.setState({
                    query: '',
                    options: [],
                    showDropDown: false,
                    isEnd: false,
                });
            }
            if (this.props.onChange) {
                this.props.onChange(query);
            }
        }, 200);
    }

    fetchSearchResults() {
        const axiosInstance = getApiAxiosInstance();
        const {
            query,
            top,
            isEnd,
            skip,
        } = this.state;
        const { filter, schoolClubSearch, isProximitySearch, clubLocation, clubSubTypeIds = [] } = this.props;
        const params = new URLSearchParams();
        params.append('query', query);
        params.append('top', 15);
        params.append('skip', skip);

        if (filter) {
            params.append('filter', filter);
        }

        if (schoolClubSearch) {
            params.append('schoolClubSearch', 'true');
        }

        if (isProximitySearch) {
            params.append('pin', `${clubLocation.latLng[0]}, ${clubLocation.latLng[1]}`);
            // our elastic index only has lngLat as a geo_point mapping
            params.append('sort', 'location.lngLat');
        }

        if (clubSubTypeIds.length > 0) {
            clubSubTypeIds.forEach((subTypeId) => {
                params.append('clubSubTypeIds', subTypeId);
            });
        }

        const that = this;
        const { CancelToken } = axios;

        if (query.length > 0) {
            if (that.cancel != undefined) {
                that.cancel();
            }
            axiosInstance.get(`/v2/search${this.props.searchEndPoint}`, {
                cancelToken: new CancelToken(((c) => {
                    that.cancel = c;
                })),
                params,
            }).then((response) => {
                const {
                    hits,
                    // total,
                } = response.data;
                that.setState({
                    options: (skip ? [...that.state.options, ...hits] : hits),
                    isLoading: false,
                    isEnd: hits.length <= 10,
                    skip: skip + 10,
                    searched: true,
                });
            }).catch((error) => {
                console.log(error);
                that.setState({
                    isLoading: false,
                    searched: true,
                });
            });
        } else {
            this.setState({
                isLoading: false,
                showDropDown: false,
                options: [],
                query: '',
                skip: 0,
                isEnd: false,
                searched: true,
            });
        }
    }

    handleLinkClick(school) {
        // this.props.expandSearch(false);
        if (this.props.clearAfterSelect) {
            this.setState({
                query: '',
                showDropDown: false,
            });
        }
        if (this.props.closeAfterSelect) {
            this.setState({
                query: this.props.schoolClubSearch ? (this.props.displaySchoolNameAfterSelect ? school.school.name : school.name) : school.displayName,
                showDropDown: false,
            });
        }
        this.props.handleSchoolSelect(school);
    }

    handleSearchBackClick() {
        this.setState({
            isLoading: false,
            showDropDown: false,
            options: [],
            query: '',
            skip: 0,
            isEnd: false,
            searched: false,
        });

        if (this.props.handleClearSchoolClick) {
            this.props.handleClearSchoolClick();
        }
    }

    render() {
        const renderSchool = (school, i) => {
            // school can be a school club or school depending on schoolClubSearch value
            const { displayName, type, location, name } = school;
            const nameValue = this.props.schoolClubSearch ? name : displayName;
            const descriptionItems = [
                ...(type ? [type] : []),
                ...(location && location.display ? [location.display] : []),
            ];
            return (
                (!this.props.entityId || (this.props.entityId && school.id !== this.props.entityId)) ? (
                    <div onClick={() => this.handleLinkClick(school)} key={`s${i}`}>
                        <div className={`row ${styles.highSchoolSearchDropdownOption}`}>
                            <div className="col-2">
                                <Img
                                    className={styles.highSchoolSearchDropdownOptionImage}
                                    src="/img/v2/icons/icon-avatar-school.svg"
                                />
                            </div>
                            <div className="col-10">
                                <div className={`${styles.name} show-ellipsis`} dangerouslySetInnerHTML={{ __html: nameValue }} />
                                <div className={`${styles.place} show-ellipsis`}>
                                    <Description desc={descriptionItems} />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
            );
        };

        const renderDropdown = () => (
            <div className="pb24">
                {this.state.options.length === 0 && !this.state.isLoading && (
                    <div className={styles.highSchoolSearchDropdownNoMatches}>
                        {this.state.searched && 'No Matches Found'}
                    </div>
                )}
                {(this.state.options.length > 0 || this.state.isLoading) && (
                    <div className={styles.highSchoolSearchDropdownOptions}>
                        {this.state.options.map((school, i) => renderSchool(school.source, i))}
                        {this.state.isLoading && (
                            <div className={styles.loading}><i className="fas fa-circle-notch fa-spin" />Loading...</div>
                        )}
                    </div>
                )}
            </div>
        );

        return (
            <div className={`${styles.highSchoolSearchContainer} ${styles.lookup} ${this.props.searchContainerClassName ? this.props.searchContainerClassName : ''} ${this.props.themeV3 ? styles.themeV3 : ''}`} ref={this.setWrapperRef}>
                <div className={`${styles.highSchoolSearchInputContainer} ${this.state.showDropDown ? styles.showOnTop : ''}`}>
                    {this.state.showDropDown && (
                        <span
                            className={`d-block d-lg-none fas fa-chevron-left ${styles.feedbackLeft}`}
                            onClick={this.handleSearchBackClick}
                        />
                    )}
                    {!this.props.themeV3 && this.props.label && (
                        <label>{this.props.label}</label>
                    )}

                    <input
                        type="text"
                        value={this.state.query}
                        className={`form-control  ${styles.highSchoolSearchInput} ${this.props.className} ${this.state.showDropDown ? 'dropdown-open' : ''}`}
                        onChange={this.handleKeyUp}
                        onPaste={this.handlePaste}
                        onFocus={this.handleOnFocus}
                        placeholder={this.props.placeholder ? this.props.placeholder : 'Search by high school name'}
                    />
                    {this.props.themeV3 && this.props.label && (
                        <label>{this.props.label}</label>
                    )}
                    {this.props.showSearchClearIcon && this.state.query.length > 0 && (
                        <span
                            className={`form-control-feedback fas fa-times-circle ${styles.feedbackRight}`}
                            onClick={this.handleSearchBackClick}
                        />
                    )}
                </div>
                {this.state.showDropDown && (
                    <div className={`${styles.highSchoolSearchDropdownContainer} ${this.props.showInviteSchool ? 'pb60' : ''}`}>
                        {renderDropdown()}
                        {this.state.searched && this.props.showInviteSchool && (
                            <div
                                className="invite-school"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    this.props.onInviteSchoolClick(e);
                                }}
                            >
                                <div className="row">
                                    <div className="col-2 d-flex align-items-center">
                                        <div className="icon circled-add" />
                                    </div>
                                    <div className="col-10 text-dark">Can&apos;t find your opponent&apos;s school?<br />Invite now!</div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

function mapDispatchToProps() {
    return {};
}

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps, mapDispatchToProps)(SchoolSearch);
